import { Directive } from '@angular/core';

@Directive({
  selector: '[phx-list-pre]',
  host: { class: 'phx-list-pre' },
})
export class PhxListItemPreDirective { }
